import React, {
  FunctionComponent,
  useContext,
  useEffect,
  useState,
} from "react";
import {
  brandedDarkTokens,
  Course,
  CourseApi,
  CoursePlayer,
  CoursePosition,
  InitialPosition,
} from "@amzn/soju-ui-framework";
import { useHistory, useParams } from "react-router-dom";

import "@amzn/soju-ui-framework/dist/umd/index.css";
import { SojuCourseApi } from "../api/SojuCourseApi";
import { useCoursesAppContext } from "../context/CoursesAppContextProvider";
import Theme from "@amzn/meridian/theme";
import { IdentityContext } from "../context/IdentityProvider";

export const CoursePlayerPage: FunctionComponent = () => {
  const {
    courseRevisionId,
    lesson: lessonIndex,
    gadget: gadgetIndex,
  } = useParams() as {
    courseRevisionId: string;
    lesson: string;
    gadget: string;
  };
  const userPrincipal = useContext(IdentityContext).hatId;
  const [course, setCourse] = useState<Course | null>(null);
  const [coursePosition, setCoursePosition] = useState<CoursePosition | null>(
    null,
  );

  const [courseApi, setCourseApi] = useState<CourseApi | null>(null);

  const { sojuApi } = useCoursesAppContext();

  useEffect(() => {
    (async () => {
      const editSession = await sojuApi.createCourseSession(
        userPrincipal,
        courseRevisionId,
        false,
      );
      setCourseApi(new SojuCourseApi(editSession));
    })();
  }, [courseRevisionId, sojuApi]);

  // Build initial position only once during mount
  const [initialPosition] = useState<InitialPosition | undefined>(
    !lessonIndex
      ? undefined
      : ({
          lessonIndex: Number(lessonIndex),
          gadgetIndex: gadgetIndex ? Number(gadgetIndex) : undefined,
        } as InitialPosition),
  );

  const history = useHistory();

  useEffect(() => {
    if (course && coursePosition) {
      const currentLessonIndex = course.lessons.findIndex(
        (lesson) => lesson.id === coursePosition.lessonId,
      );
      if (currentLessonIndex >= 0) {
        const lessonNumber = currentLessonIndex + 1;
        const currentGadgetIndex = course.lessons[
          currentLessonIndex
        ].gadgets.findIndex((gadget) => gadget.id === coursePosition.gadgetId);

        if (currentGadgetIndex >= 0) {
          const gadgetNumber = currentGadgetIndex + 1;
          // update url path
          history.push(
            `/courses/learn/${courseRevisionId}/lessons/${lessonNumber}/gadgets/${gadgetNumber}`,
          );
        } else {
          history.push(
            `/courses/learn/${courseRevisionId}/lessons/${lessonNumber}`,
          );
        }
      }
    }
  }, [course, courseRevisionId, coursePosition, history]);

  if (courseApi) {
    return (
      <Theme tokens={brandedDarkTokens}>
        <CoursePlayer
          courseId={courseRevisionId}
          asin={courseRevisionId}
          courseApi={courseApi}
          onPositionChange={setCoursePosition}
          initialPosition={initialPosition}
          onCourseChange={setCourse}
        />
      </Theme>
    );
  }

  return null;
};
